import { ObjectBuilder, QueryBuilder } from '../../graphQlBuilder';
class GenerateUploadUrlMutationBuilder {
    static buildQuery(parameters) {
        return new QueryBuilder().mutation(builder => {
            for (const alias in parameters) {
                const fileParameters = parameters[alias];
                builder = builder.object(alias, GenerateUploadUrlMutationBuilder.generateUploadUrlFields
                    .argument('contentType', fileParameters.contentType)
                    .argument('expiration', fileParameters.expiration)
                    .argument('prefix', fileParameters.prefix)
                    .argument('acl', fileParameters.acl));
            }
            return builder;
        });
    }
}
Object.defineProperty(GenerateUploadUrlMutationBuilder, "generateUploadUrlFields", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: new ObjectBuilder()
        .name('generateUploadUrl')
        .field('url')
        .field('publicUrl')
        .field('method')
        .object('headers', builder => builder.field('key').field('value'))
});
export { GenerateUploadUrlMutationBuilder };
//# sourceMappingURL=GenerateUploadUrlMutationBuilder.js.map